<template lang="pug">
  DashHudsonScriptInner(:key="componentKey" :location="location" :version="version")
    template(#title="")
      slot(name="title")
</template>

<script>
  import DashHudsonScriptInner from "@components/PDP/DashHudsonScriptInner.vue";

  export default {
    name: "DashHudsonScript",

    props: {
      location: {
        type: String,
        default: 'Dash Hudson Widget',
      },
      version: {
        type: Number,
        default: 1
      }
    },

    components: {
      DashHudsonScriptInner
    },

    computed: {
      componentKey() {
        return this.$route.path;
      }
    }
  };
</script>
